import { render, staticRenderFns } from "./Siege.vue?vue&type=template&id=0be875b0&scoped=true&"
import script from "./Siege.vue?vue&type=script&lang=js&"
export * from "./Siege.vue?vue&type=script&lang=js&"
import style0 from "./Siege.vue?vue&type=style&index=0&id=0be875b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be875b0",
  null
  
)

export default component.exports